import { useQuery } from "@apollo/client";

import { TASKS_COUNT_QUERY } from "./schema";
import { SUGGESTED_TASKS_COUNT_QUERY } from "./SuggestedTasks/schema";

/**
 *  Get Counts for Open, Overdue, and Suggested tasks
 */
export const useTaskCountQueries = (tenantId: string | undefined) => {
  // Query 1: Open tasks count (OPEN + IN_PROGRESS)
  const openQuery = useQuery(TASKS_COUNT_QUERY, {
    variables: { search: `tenantId:${tenantId} taskStatus:OPEN|IN_PROGRESS` },
    skip: !tenantId,
  });

  // Query 2: Overdue tasks count (status:OVERDUE)
  const overdueQuery = useQuery(TASKS_COUNT_QUERY, {
    variables: { search: `tenantId:${tenantId} status:OVERDUE` },
    skip: !tenantId,
  });

  // Query 3: Suggested tasks count
  const suggestedQuery = useQuery(SUGGESTED_TASKS_COUNT_QUERY, {
    variables: { search: `tenantId:${tenantId}` },
    skip: !tenantId,
  });

  return {
    openQuery,
    overdueQuery,
    suggestedQuery,
  };
};
